import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllCommissionSettingServices = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const created_between = urlQueries["created_between"] || "";
  const commissionSettingId = urlQueries?.["commissionable-id"] || "";
  const commissionableType = urlQueries?.["commissionable-type"] || "";
  const allCommissionSettingServices = useQuery({
    queryKey: [
      ...CACHE_KEYS.COMMISSION_SETTING,
      page,
      debouncedQuery,
      per_page,
      commissionableType,
      commissionSettingId,
      created_between,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.COMMISSION_SETTING,
        searchParams: {
          "filter[commissionable_type]": commissionableType,
          "filter[commissionable_id]": commissionSettingId,
          "filter[created_between]": created_between,
          page: page,
          per_page: per_page,
          include: "commissionable,partner",
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allCommissionSettingServices },
    states: { searchQuery, setSearchQuery },
  };
};
